<template>
  <div class="form-item">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>

<style scoped lang="scss">
@use "@/assets/styles/functions" as *;

.form-item {
  padding: .8rem 1.25rem;
  font-size: px2rem(14px);

  + .form-item {
    border-top: 1px solid #DDD;
  }
}
</style>
